import { z } from "zod";
/** Email addresses are trimmed and lower-cased so "Ayesha@Example.com " and "ayesha@example.com" are the same account. */
export const EmailSchema = z
    .string()
    .trim()
    .toLowerCase()
    .max(254, "Email must be at most 254 characters")
    .pipe(z.email("Enter a valid email address"));
/** Person names allow any letters, including accents (e.g. "José"). */
export const PersonNameSchema = z
    .string()
    .trim()
    .min(1, "Name is required")
    .max(100, "Name must be at most 100 characters");
export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 128;
export const PasswordSchema = z
    .string()
    .min(PASSWORD_MIN_LENGTH, `Password must be at least ${PASSWORD_MIN_LENGTH} characters`)
    .max(PASSWORD_MAX_LENGTH, `Password must be at most ${PASSWORD_MAX_LENGTH} characters`);
/** Identifiers generated by the auth system (opaque strings). */
export const IdSchema = z.string().trim().min(1).max(64);
export const IsoDateTimeSchema = z.iso.datetime({ offset: true });
//# sourceMappingURL=primitives.js.map